var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{class:_vm.$vuetify.breakpoint.xlOnly ? 'table' : '',attrs:{"head":_vm.target !== 'manual' ? _vm.tableHeadTrigger : _vm.tableHead}},_vm._l((_vm.items),function(item){return _c('SettingsPushNotificationsTableItem',{key:item.id,attrs:{"item":item,"onDownloadPageData":_vm.onDownloadPageData,"target":_vm.target}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }